import React from 'react';
import ReportTable from "../../../hoc/ReportTable/ReportTable";
import {ReportSectionHeader} from "../SectionHeader";


const AdverseCorporateEventExposureComponent = (props) => (

    <div>
        <ReportSectionHeader>
			{"2-YR. Rule 10b-5 Exposure: Adverse Corporate Events"}
        	
        </ReportSectionHeader>
        <ReportTable
                settings={[
                {
                    header: 'Trading Day',
                    accessor: 'date',
                    tooltip: 'Trading days presented below are two consecutive trading days where the latter shows stock price impact stemming from the high-risk adverse events.'
                },
                {
                    header: 'ACE Type',
                    accessor: 'statType'
                },
                {
                    header: 'Severe',
                    accessor: 'severe',
                    dollarValue: false,
                    tooltip: 'The t-statistic is greater than 1.96 indicating statistical significance at the 95% Confidence Level, within two standard deviations'
                },
                {
                    header: 'Closing Stock Price',
                    accessor: 'closingPrice',
                    dollarValueWithCommas: true,
                    centerRightJustified: true
                },
                {
                    header: 'Shares Outstanding~(000s)',
                    accessor: 'sharesOutStanding',
                    dollarValue: false,
                    formatNumberWithCommas: true,
                    truncateDecimal: true,
                    inThousands: true,
                    centerRightJustified: true,
                    round2whole: true
                },
                {
                    header: 'Approx. Market Cap.~(000s)', 
                    accessor: 'approxMarketCap',
                    dollarValue: true,
                    formatNumberWithCommas: true,
                    truncateDecimal: true,
                    inThousands: true,
                    centerRightJustified: true
                },
                {
                    header: 'Approx. Market Cap. Losses~(000s)',
                    accessor: 'approxMarketCapLoss',
                    dollarValue: true,
                    formatNumberWithCommas: true,
                    truncateDecimal: true,
                    inThousands: true,
                    centerRightJustified: true,
                    tooltip: 'Market Cap. Losses are equal to the changes in market cap. on trading days affected by the high-risk adverse event. If the change (daily log return) in stock price, after controlling for market and industry forces is statistically significant at the 95% Confidence Level, the trading day that corresponds to the corrective event will be presented here.'
                }
            ]}
            data={props.adverseCorporateEvent}
            name={"adverseCorporateEvents"}
            
        />
        <div class="AceBoldText">
		* Bold <span class="AceItalicsText">records indicates severe</span>
		</div>

    </div>
);


export default AdverseCorporateEventExposureComponent;


// WEBPACK FOOTER //
// ./src/common/components/AdverseCorporateEventExposure/AdverseCorporateEventExposureComponent.js